export const appLinks = {
  privacyLink: 'https://www.purplegarden.co/privacy'
};

const Const = {
  application: {
    error: 'application:error',
    clearError: 'application:clearError'
  },
  personalizedReading: {
    loading: 'personalizedReading:loading',
    loaded: 'personalizedReading:loaded',
    questionsLoaded: 'personalizedReading:questionsLoaded'
  },
  user: {
    loading: 'user:loading',
    loaded: 'user:loaded',
    error: 'user:error',
    emailValidated: 'user:emailValidated',
    emailValidationError: 'user:emailValidationError',
    emailValidationErrorClear: 'user:emailValidationErrorClear',
    emailError: 'user.emailError',
    nicknameChanged: 'user:nicknameChanged',
    nicknameSubmitted: 'user:nicknameSubmitted',
    nicknameValidated: 'user:nicknameValidated',
    nicknameValidationError: 'user:nicknameValidationError',
    MPIdentify: 'user.MPIdentify'
  },
  payments: {
    loading: 'payments:loading',
    loaded: 'payments:loaded',
    paymentProcessing: 'payments:paymentProcessing',
    setPaymentsParams: 'payments:setPaymentsParams',
    setPaymentsData: 'payments:setPaymentsData',
    setPaymentsResponce: 'payments:setPaymentsResponce',
    clearPaymentsParams: 'payments:clearPaymentsParams',
    setPaymentsCardData: 'payments:setPaymentsCardData'
  },
  order: {
    save: 'order:save',
    clearOrderKey: 'order:clearOrderKey'
  },
  wizard:{
    aboutMe: {
      loading:'aboutMe:loading',
      loaded: 'aboutMe:loaded',
      error: 'aboutMe:error'
    },
    question:{
      loading:'question:loading',
      loaded: 'question:loaded',
      error: 'question:error'
    },
    advisorSelection: {
      advisorsLoaded: 'advisorSelection:advisorsLoaded',
      emailValidated: 'advisorSelection:emailValidated',
      emailValidationError: 'advisorSelection:emailValidationError',
      emailValidationErrorClear: 'advisorSelection:emailValidationErrorClear',
      emailExists: 'advisorSelection.emailExists'
    },
    payment:{
      loading:'payment:loading',
      loaded: 'payment:loaded',
      paymentProcessing: 'payments:paymentProcessing',
      setPaymentsParams: 'payments:setPaymentsParams',
      setPaymentsData: 'payments:setPaymentsData',
      setPaymentsResponce: 'payments:setPaymentsResponce',
      clearPaymentsParams: 'payments:clearPaymentsParams',
      setPaymentsCardData: 'payments:setPaymentsCardData',
      submitted: 'payments:submitted'
    },
    stepLoading: 'wizard:stepLoading',
    signupEventSent: 'wizard:signupEventSent'
  },
  reading: {
    loading: 'reading:loading',
    loaded: 'reading:loaded',
    error: 'reading:error',
    viewed: 'reading:viewed'
  },
  navigation: {
    initialScreen: 'navigation:initialScreen',
    updateCurrentScreen: 'navigation:updateCurrentScreen'
  }
};

export default Const;
